import { IRapPageContext, IRapService, Services, RapService } from "../Context";
import { pca } from "../components/AuthHandler/AuthHandler";
/**
 * This is the basic data that describes the state of the page being executed.
 *  It has basic information about the service and the entities accessed.
 */
export interface IAuthenticationData {
    /**
     * Authentication token.
     */
    idToken: string;

    /**
     * Whether we are running inside of MS Teams.
     */
    isRunningInTeams: boolean;


    /**
     * Whether we are in full screen mode inside of Teams.
     */
    isFullScreen: boolean | undefined;
}

export interface IRapAuthenticationService extends IRapService {
    setIdToken(idToken: string): void;
    getData(): IAuthenticationData;
    getToken(): Promise<string>;
}

export class RapAuthenticationService extends RapService implements IRapAuthenticationService {
    private authData: IAuthenticationData;

    public _serviceStart(pageContext: IRapPageContext) {
        super._serviceStart(pageContext);

        // Fetch authorization token for page
        this._initializeService();
    }

    private _initializeService(): void {
        this.authData = { idToken: "", isRunningInTeams: false, isFullScreen: undefined };
    }

    public setIdToken(idToken: string): void {
        this.authData.idToken = idToken;
    }

    public getData(): IAuthenticationData {
        return this.authData;
    }

    public async getToken(): Promise<string> {
        const activeAccount = pca.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
        const accounts = pca.getAllAccounts();

        if (!activeAccount && accounts.length === 0) {
            console.log("User not signed in");
            /*
            * User is not signed in. Throw error or wait for user to login.
            * Do not attempt to log a user in outside of the context of MsalProvider
            */   
        }
        const request = {
            scopes: ["User.Read"],
            account: activeAccount || accounts[0]
        };

        const authResult = await pca.acquireTokenSilent(request);

        return authResult.accessToken
    }
}

Services.add("IRapAuthenticationService", { serviceFactory: RapAuthenticationService });
